import css from "./index.module.less";
import React from "react";

export interface AppProps {
  hideHeader?: boolean;
  children;
  contentFullFill?: boolean;
}

export const App = (props: AppProps) => {
  const { children, contentFullFill, hideHeader } = props;
  return (
    <div className={css.app}>
      {!hideHeader && (
        <div className={`${css.container}`}>
          <img
            src={require("../images/Pionexlogo@2x.svg")}
            alt={""}
            width={117}
            height={29}
          />
        </div>
      )}
      <div className={`${css.contentBox} ${contentFullFill ? css.full : ""}`}>
        {children}
      </div>
    </div>
  );
};
